const STORAGE_KEY_VERBOSE_LOG_LEVEL = "al_verbose_log_level";
export var VerboseLogLevels;
(function (VerboseLogLevels) {
    VerboseLogLevels["NONE"] = "NONE";
    VerboseLogLevels["APP"] = "APP";
    VerboseLogLevels["APP_AND_REDUX"] = "APP_AND_REDUX";
})(VerboseLogLevels || (VerboseLogLevels = {}));
let verboseLogLevel = VerboseLogLevels.NONE;
// non production default to app and redux
if (process.env.NODE_ENV !== 'production') {
    verboseLogLevel = VerboseLogLevels.APP_AND_REDUX;
}
// check
const verboseLogLevelHint = typeof (localStorage) !== 'undefined' ? localStorage.getItem(STORAGE_KEY_VERBOSE_LOG_LEVEL) : 0;
if (verboseLogLevelHint) {
    const verboseLogLevelHintValue = parseInt(verboseLogLevelHint);
    if (!isNaN(verboseLogLevelHintValue)) {
        if (verboseLogLevelHintValue >= 2) {
            verboseLogLevel = VerboseLogLevels.APP_AND_REDUX;
        }
        else if (verboseLogLevelHintValue >= 1) {
            verboseLogLevel = VerboseLogLevels.APP;
        }
    }
}
export default class VerboseLogLevelUtils {
    static getLevel() {
        return verboseLogLevel;
    }
}
//# sourceMappingURL=VerboseLogLevelUtils.js.map